module.exports = __webpack_public_path__ + "static/media/Ryan Coble-Neal.41a65999.jpg";